// Shared shell for the public pages (login, password reset, e-mail
// verification, invitations): a centred card with the language switch.
import { Link } from 'react-router-dom';
import { useLang, useT } from '../../lib/i18n.jsx';
import { useTheme } from '../../lib/theme.jsx';
import { LangToggle } from '../../components/Topbar.jsx';

export default function PublicCard({ title, subtitle, children, footer }) {
  const t = useT();
  const { lang, setLang } = useLang();
  const { dark } = useTheme();
  return (
    <div className="login-shell" data-theme={dark ? 'dark' : 'light'}>
      <div className="login-card">
        <div className="login-top">
          <LangToggle lang={lang} setLang={setLang} />
        </div>
        <div className="login-brand">
          <div className="mark">D</div>
          <div className="name">
            DMRS<span>Console</span>
          </div>
        </div>
        <h1 className="login-title">{title}</h1>
        {subtitle && <p className="login-sub">{subtitle}</p>}
        {children}
        <div className="login-foot">{footer ?? <Link to="/login">{t('public.toLogin')}</Link>}</div>
      </div>
    </div>
  );
}

export function Notice({ tone = 'ok', children }) {
  return (
    <div className={tone === 'error' ? 'login-error' : 'login-ok'} role={tone === 'error' ? 'alert' : 'status'}>
      {children}
    </div>
  );
}
